const Index = () => import('../pages/Index.vue');

const routes = [
    {
        path: '/library/reservation/punishments',
        name: 'library-reservation-punishments',
        component: Index,
        meta: {
            permission: 'libraryreservationpunishment_index'
        }
    }
];

export default routes;
